import { config } from '../app/config.js';

const _nameOfInitCallback = 'lagweblibs_googlemapsapi_init';
const _srcMapsApi = 'https://maps.googleapis.com/maps/api/js?key=' + config.serviceKeys.googleAPI + '&libraries=places&callback=' + _nameOfInitCallback;
// To obtain an API key, see https://developers.google.com/maps/documentation/javascript/tutorial#api_key.

export const loader = new Promise((resolve) => {
    // If already loaded then just resolve.
    if (window.google && window.google.api)
        resolve(window.google.api);
    else {
        // Create google maps api callback (when ready), which triggers promise resolution.
        window[_nameOfInitCallback] = function () {
            resolve(window.google.maps);
        };

        // Inject script tag into document to load maps api.
        const script = document.createElement('script');
        script.src = _srcMapsApi;
        const container = document.querySelector('script') || document.body;
        container.parentNode.insertBefore(script, container);
    }
});